module.exports = __webpack_public_path__ + "img/bi_cloud-check-fill.30c4f5f8.svg";